define('responsive-gameday/views/render/PitchByPitchViewRender',['require','exports','module','./ViewRender','../../helpers/PitchListToggle','Wax/get!view-templates/pitchByPitch/pitchByPitch','Wax/get!view-templates/pitchByPitch/events','Wax/get!view-templates/pitchByPitch/pitches','Wax/get!view-templates/playByPlay/play','Wax/get!view-templates/playByPlay/action','Wax/get!view-templates/playByPlay/pitch'],function(require,exports,module){
    var ViewRender = require('./ViewRender'),
        PitchListToggle = require("../../helpers/PitchListToggle"),
        Superclass;

    function PitchByPitchViewRender(){
        Superclass.constructor.call(this,
            require('Wax/get!view-templates/pitchByPitch/pitchByPitch'),{
                eventsView  : require( 'Wax/get!view-templates/pitchByPitch/events' ),
                pitchesView : require( 'Wax/get!view-templates/pitchByPitch/pitches' ),
                playView    : require( 'Wax/get!view-templates/playByPlay/play' ),
                actionView  : require( 'Wax/get!view-templates/playByPlay/action' ),
                pitchView   : require( 'Wax/get!view-templates/playByPlay/pitch' )
            }
        );
    }
    ViewRender.spawn(PitchByPitchViewRender).define({
        setPitchToggler : function(controller){
            var pitchToggler = this.pitchToggler = this.pitchToggler || new PitchListToggle(controller);

            pitchToggler.className = 'pitches_visible';
            pitchToggler.on(controller.childWrapper || controller.view, '#events .play:not(.nonplay) .detail');

            this.viewState.pitchState=pitchToggler.pitchesState;

        }
    });

    Superclass=PitchByPitchViewRender.superclass;

    return PitchByPitchViewRender;
});
